module.exports = __webpack_public_path__ + "static/media/retail.802687f5.svg";